import { goToNews } from '@/app/routing/events'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'

export const AppCenterNews = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].pages.tasks.name.vote
  return (
    <div
      className={classes.root}
      onClick={() => goToNews({ variant: 'telegramApps' })}
    >
      <img src="/assets/backgrounds/appsCenterBackground.webp" />
      <div className={classes.wrapper}>
        <span className={classes.voteForGamed}>{text}</span>
        <span className={classes.heading}>Telegram Apps Center Case</span>
      </div>
    </div>
  )
}

// 123
